var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.403,
    height: 22.965,
    viewBox: "0 0 33.403 22.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,160c10.439,0,16.7,11.482,16.7,11.482s-6.263,11.482-16.7,11.482S0,171.482,0,171.482,6.263,160,16.7,160Zm0,2.088c-7.349,0-12.53,6.787-14.249,9.395,1.716,2.605,6.9,9.395,14.249,9.395s12.53-6.787,14.249-9.395C29.234,168.877,24.053,162.088,16.7,162.088Zm0,2.088a7.307,7.307,0,1,1-7.307,7.307A7.307,7.307,0,0,1,16.7,164.175Zm0,2.088a5.219,5.219,0,1,0,5.219,5.219A5.226,5.226,0,0,0,16.7,166.263Z",
    transform: "translate(0 -160)",
    fill: "#053e74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.a48244505c5151ca76218dbd0b70edd6.svg";
export { ForwardRef as ReactComponent };